import "./Profile.css";

function Profile(props) {
    return <img className="profile-pic" src={props.image} />
}

export default Profile;